module.exports = __webpack_public_path__ + "static/media/greta_thunberg.fe30d43d.jpeg";